import React, {useContext} from "react"
// import {Helmet} from "react-helmet"
import {LabelContext} from "../../assets/js/labelDataContext"
import DietData from "../../assets/js/dietData"
import DietData3 from "../../assets/js/dietData3"

const OrderConfirm = props => {
    const value = useContext(LabelContext)
    // const client = value.labelInfo.client
    var dataPrice = undefined;
    var firstDeliveryDay = undefined;
    var dayPrice = "";
    var totalOrderPrice = "";
    var daysCount = "";
    var isPromo = 0;
    var discount = 0;
    // const btnDisabled =
    //     client.firstName.length > 0 &&
    //     client.lastName.length > 0 &&
    //     client.email.length > 0 &&
    //     client.phoneNumber.length > 0


    const diffDays = (dDate1, dDate2, isSaturdayCatering, isSundayCatering) => {
        const dataPoczatkowa = new Date('2023-12-24');
        const dataKoncowa = new Date('2024-1-2');
        let days = 0
        if (dDate1.getDay() == 1) {
            firstDeliveryDay = new Date(dDate1.getDate()-2);
          } else {
             firstDeliveryDay = new Date(dDate1.getDate()-1);
          } 
        for (
            let d = new Date(
                dDate1.getFullYear(),
                dDate1.getMonth(),
                dDate1.getDate()
            );
            d <= dDate2;
            d.setDate(d.getDate() + 1)
        ) {

            if ((d.getDay() == 0 && !isSundayCatering) || (d.getDay() == 6 && !isSaturdayCatering)) {
                console.log("day " + d.getDay() + " isSundayCatering: " + isSundayCatering + " isSaturdayCatering: " + isSaturdayCatering)
            } else {
                if (d >= dataPoczatkowa && d <= dataKoncowa)
                {
                    
                }
                else
                {
                  days += 1  
                    }
                
            }
        }
        return days
    }
    const checkPromoCode = () => {
        if (value.labelInfo.client.promo_code.toLowerCase() == "krzeniewski") 
        {

            discount = 5;
            isPromo = 1;
            return "-5%";
        }

        return "Brak";
    }

    const getDayPrice = () => {
        
        if (value.labelInfo.dietDay == 2) {
            let option = DietData[value.labelInfo.diet].prices[value.labelInfo.dietOption].option;
            
            let totalPrice = 29.99;
            if (option <= 2500 && option > 2000)
                totalPrice = 35;
            if (option <= 3000 && option > 2500)
                totalPrice = 40;
            if (option > 3000)
                totalPrice = 45;
            totalPrice += DietData[value.labelInfo.diet].testExtraPay;
            dayPrice = totalPrice.toFixed(2) + " ";
            daysCount = "1";
            totalOrderPrice = totalPrice.toFixed(2) + " ";
            dataPrice = totalPrice.toFixed(2) + " zł";
            return dataPrice;
        } else if (value.labelInfo.dietDay == 1) {
            let days = diffDays(value.labelInfo.date.from, value.labelInfo.date.to, value.labelInfo.isSaturdayCatering, value.labelInfo.isSundayCatering)
            let price =
                DietData3[value.labelInfo.diet].prices[value.labelInfo.dietOption].days[0].price
            if (days >= 14)
                price =
                    DietData3[value.labelInfo.diet].prices[value.labelInfo.dietOption].days[1].price
            if (days >= 21)
                price =
                    DietData3[value.labelInfo.diet].prices[value.labelInfo.dietOption].days[2].price
            if (days >= 28)
                price = DietData3[value.labelInfo.diet].prices[value.labelInfo.dietOption].days[3].price

            price += 13;
            dataPrice = "" + price + " zł";
            return dataPrice;
        } else {
            let days = diffDays(value.labelInfo.date.from, value.labelInfo.date.to, value.labelInfo.isSaturdayCatering, value.labelInfo.isSundayCatering)
            let price =
                DietData[value.labelInfo.diet].prices[value.labelInfo.dietOption].days[0]
                    .price
            if (days >= 14)
                price =
                    DietData[value.labelInfo.diet].prices[value.labelInfo.dietOption]
                        .days[1].price
            if (days >= 21)
                price =
                    DietData[value.labelInfo.diet].prices[value.labelInfo.dietOption]
                        .days[2].price
            if (days >= 28)
                price =
                    DietData[value.labelInfo.diet].prices[value.labelInfo.dietOption]
                        .days[3].price
            
            price += 13;
           
            dataPrice = ""+ price + " zł";
            
            return dataPrice;

        }
    }

    const calculatePrice = () => {
        
        if (value.labelInfo.dietDay == 2) {
            let option = DietData[value.labelInfo.diet].prices[value.labelInfo.dietOption].option;
            
            let totalPrice = 35.99;
            if (option <= 2500 && option > 2000)
                totalPrice = 40.99;
            if (option <= 3000 && option > 2500)
                totalPrice = 45.99;
            if (option > 3000)
                totalPrice = 50.99;
            totalPrice += DietData[value.labelInfo.diet].testExtraPay;
            dayPrice = totalPrice.toFixed(2) + " ";
            daysCount = "1";
            totalOrderPrice = totalPrice.toFixed(2) + " ";
            dataPrice = totalPrice.toFixed(2) + " zł";
            return dataPrice;
        } else if (value.labelInfo.dietDay == 1) {
            let days = diffDays(value.labelInfo.date.from, value.labelInfo.date.to, value.labelInfo.isSaturdayCatering, value.labelInfo.isSundayCatering)
            let price =
                DietData3[value.labelInfo.diet].prices[value.labelInfo.dietOption].days[0].price
            if (days >= 14)
                price =
                    DietData3[value.labelInfo.diet].prices[value.labelInfo.dietOption].days[1].price
            if (days >= 21)
                price =
                    DietData3[value.labelInfo.diet].prices[value.labelInfo.dietOption].days[2].price
            if (days >= 28)
                price = DietData3[value.labelInfo.diet].prices[value.labelInfo.dietOption].days[3].price

            price += 13;
            price -= price * (discount/100.0);
            let totalPrice = price * days;
            dayPrice = price.toFixed(2) + " ";
            daysCount = days + " ";
            totalOrderPrice = totalPrice.toFixed(2) + " ";
            dataPrice = "" + days + " dni x " + price + " zł = " + totalPrice + " zł";
            return dataPrice;
        } else {
            let days = diffDays(value.labelInfo.date.from, value.labelInfo.date.to, value.labelInfo.isSaturdayCatering, value.labelInfo.isSundayCatering)
            let price =
                DietData[value.labelInfo.diet].prices[value.labelInfo.dietOption].days[0]
                    .price
            if (days >= 14)
                price =
                    DietData[value.labelInfo.diet].prices[value.labelInfo.dietOption]
                        .days[1].price
            if (days >= 21)
                price =
                    DietData[value.labelInfo.diet].prices[value.labelInfo.dietOption]
                        .days[2].price
            if (days >= 28)
                price =
                    DietData[value.labelInfo.diet].prices[value.labelInfo.dietOption]
                        .days[3].price
            
            price += 13;
            price -= price * (discount/100.0);
            let totalPrice = price * days

            dayPrice = price.toFixed(2) + " ";
            daysCount = days + " ";
            totalOrderPrice = totalPrice.toFixed(2) + " ";
            dataPrice = "" + days + " dni x " + price + " zł = " + totalPrice + " zł";
            
            return dataPrice;

        }
    }
    return (
        <>
            <div className="order-confirm-box">
                <h3>Potwierdzenie zamówienia</h3>

                <div className="row">
                    <div className="col-md-12">
                        <table
                            className="table-summary"
                            css={{width: "100%"}}
                            cellspacing="0"
                            cellpadding="0"
                            bgcolor="#efefef"
                        >
                            <tbody>
                            <tr>
                                <td align="left">
                                    <h4>Podsumowanie:</h4>
                                </td>
                            </tr>
                            <tr>
                                <td align="left">
                                    <table
                                        css={{width: "100%"}}
                                        className="cke_show_border"
                                        cellspacing="1"
                                        cellpadding="1"
                                        border="0"
                                        align="left"
                                    >
                                        <tbody>
                                        <tr>
                                            <td>Dieta:</td>
                                            <td>
                                                <strong>
                              <span>
                                {DietData[value.labelInfo.diet].title}
                              </span>
                                                </strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Kaloryczność:</td>
                                            <td>
                                                <strong>
                              <span>
                                {
                                    DietData[value.labelInfo.diet].prices[
                                        value.labelInfo.dietOption
                                        ].option
                                } kcal
                              </span>
                                                </strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Okres zamówienia:</td>
                                            <td>
                                                <strong>
                              <span>
                                {value.labelInfo.date.from.toLocaleDateString()}{" "}
                                  - {value.labelInfo.date.to.toLocaleDateString()}
                              </span>
                                                </strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Cena za dzień:</td>
                                            <td>
                                                <strong>
                              <span>
                                {getDayPrice()}
                              </span>
                                                </strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Rabaty:</td>
                                            <td>
                                                <strong>
                              <span>
                                {checkPromoCode()}
                              </span>
                                                </strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Do zapłaty:</td>
                                            <td>
                                                <strong>
                                                    <span>{calculatePrice()}</span>
                                                </strong>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <p css={{lineHeight: "150%"}}>
                                        <br/>
                                    </p>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <table
                            className="table-summary"
                            css={{width: "100%"}}
                            cellspacing="0"
                            cellpadding="0"
                            bgcolor="#efefef"
                        >
                            <tbody>
                            <tr>
                                <td align="left">
                                    <h4>Moje dane:</h4>
                                </td>
                            </tr>
                            <tr>
                                <td align="left">
                                    <table
                                        css={{width: "100%"}}
                                        className="cke_show_border"
                                        cellspacing="1"
                                        cellpadding="1"
                                        border="0"
                                        align="left"
                                    >
                                        <tbody>
                                        <tr>
                                            <td>Imię:</td>
                                            <td>
                                                <strong>
                                                    <span>{value.labelInfo.client.firstName}</span>
                                                </strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Nazwisko:</td>
                                            <td>
                                                <strong>
                                                    <span>{value.labelInfo.client.lastName}</span>
                                                </strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Email:</td>
                                            <td>
                                                <strong>
                                                    <span>{value.labelInfo.client.email}</span>
                                                </strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Nr telefonu:</td>
                                            <td>
                                                <strong>
                                                    <span>{value.labelInfo.client.phoneNumber}</span>
                                                </strong>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <p css={{lineHeight: "150%"}}>
                                        <br/>
                                    </p>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="col-md-6">
                        <table
                            className="table-summary"
                            css={{width: "100%"}}
                            cellspacing="0"
                            cellpadding="0"
                            bgcolor="#efefef"
                        >
                            <tbody>
                            <tr>
                                <td>
                                    <h4>Dane dostawy:</h4>
                                </td>
                            </tr>
                            <tr>
                                <td align="left">
                                    <table
                                        css={{width: "100%"}}
                                        className="cke_show_border"
                                        cellspacing="1"
                                        cellpadding="1"
                                        border="0"
                                        align="left"
                                    >
                                        <tbody>
                                        <tr>
                                            <td>Miasto:</td>
                                            <td>
                                                <strong>
                                                    <span>{value.labelInfo.address.city}</span>
                                                </strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Kod pocztowy:</td>
                                            <td>
                                                <strong>
                                                    <span>{value.labelInfo.address.zipCode}</span>
                                                </strong>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Adres:</td>
                                            <td>
                                                <strong>
                              <span>
                                {value.labelInfo.address.street}{" "}
                                  {value.labelInfo.address.line1}{" "}
                                  {value.labelInfo.address.line2}
                              </span>
                                                </strong>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <p css={{lineHeight: "150%"}}>
                                        <br/>
                                    </p>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div><b>Zamawiam z obowiązkiem zapłaty</b></div>
                <form>
                    <div
                        variant="contained"
                        color="primary"
                        aria-label="text primary button group"
                        style={{marginTop: 15}}
                    >
                        <button onClick={() => value.prevPage()} className="btn-next">
                            Wstecz
                        </button>
                        <button
                            onClick={() => value.confirmOrder(dataPrice, dayPrice, totalOrderPrice, daysCount, firstDeliveryDay, isPromo)}
                            className="btn-confirm"
                        >
                            Zamawiam
                        </button>
                    </div>
                </form>
            </div>
        </>
    )
}
export default OrderConfirm
